<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <script src='https://kit.fontawesome.com/a076d05399.js' crossorigin='anonymous'></script>
  <script src="https://ajax.googleapis.com/ajax/libs/angularjs/1.6.9/angular.min.js"></script>
</head>
<body>


<div class="container-fluid">
<div id="loader" *ngIf="loading"></div>

<div class="container-fluid" *ngIf="!loading"> 
<form  class="well form-horizontal" [formGroup]="userForm">
  <h2>Formulaire De Modification Des Données Utilisateurs</h2>
  <div *ngIf="!user.natureactivite || user.natureactivite=='Autre/null' || !user.activite || user.activite=='Autre/null'|| user.regimefiscalimpot=='Autre/null'
  || !user.regimefiscalimpot && user.nature=='Personne Physique' || !user.matriculefiscale|| !user.adresseactivite || !user.codepostal">
 <h4 *ngIf="user.usertype=='Client'"> veuillez renseigner les champs obligatoires (*)</h4>
</div>
<fieldset>
  <legend>Informations supplémentaires</legend>
  <table>
    <tbody>
      <tr>
        <td>
          <div class="input-container">
            <label class="col-md-3 control-label">RIB:</label>
            <div *ngIf="submitted && f.compte.errors" class="invalid">
              <div *ngIf="f.compte.errors.minlength">numéro invalide</div>
          </div>
            <div class="col-md-9 inputGroupContainer">
               <div class="input-group"><span class="input-group-addon"><i class="fa fa-refresh fa-spin" *ngIf="processing"></i></span>
                <input class="input-field" type="text" placeholder="RIB" id="selectfiscalimpot"(input)="controllength(this.userForm.controls['compte'],$event)" formControlName="compte">
              </div>
            </div>
         </div>
</td>
<!--<td>
  <div class="input-container">
    <label class="col-md-3 control-label">code banque:</label>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="code banque" id="selectfiscalimpot" formControlName="banque">
      </div>
    </div>
 </div>
</td>--> 
<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Numéro de carte:</label>
    <div *ngIf="submitted && f.carte.errors" class="invalid">
      <div *ngIf="f.carte.errors.minlength">numéro invalide</div>
  </div>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="fa fa-refresh fa-spin" *ngIf="processing"></i></span>
        <input class="input-field" type="text" placeholder="numéro de carte" id="selectfiscalimpot"(input)="controllength(this.userForm.controls['carte'],$event)" formControlName="carte">
      </div>
    </div>
 </div>
</td>
</tr>
<tr>

<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Numéro d'affiliation:</label>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="numéro affiliation" id="selectfiscalimpot" formControlName="affiliation">
      </div>
    </div>
 </div>
</td>
<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Numéro terminal:</label>
    <div class="col-md-9 inputGroupContainer">
       <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="numéro terminal" id="selectfiscalimpot" formControlName="terminal">
      </div>
    </div>
 </div>
</td>
</tr>

</tbody>
</table>
<!--<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Taux de la charge patronale:</label>
    <div class="col-md-7 inputGroupContainer">
      <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="Renseigner régime fiscal en matière d'impôts directs" id="selectfiscalimpot" formControlName="tauxchargepatronale">
      </div>
   </div>
    </div>
</td>
<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Taux de l'accident de travail:</label>
    <div class="col-md-8 inputGroupContainer">
      <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="Renseigner régime fiscal en matière d'impôts directs" id="selectfiscalimpot" formControlName="tauxaccidenttravail">
      </div>
   </div>
    </div>
</td>
<td>
  <div class="input-container">
    <label class="col-md-3 control-label">Régime horaire:</label>
    <div class="col-md-8 inputGroupContainer">
      <div class="input-group"><span class="input-group-addon"><i class="glyphicon glyphicon-earphone"></i></span>
        <input class="input-field" type="text" placeholder="Renseigner régime fiscal en matière d'impôts directs" id="selectfiscalimpot" formControlName="regimehoraire">
      </div>
   </div>
    </div>
</td>
      </tr> --> 
</fieldset>
  <fieldset>
    <legend> Informations Spécifiques</legend>
  <!--<table>
      <tbody>
        <tr>
          <td>
            <div class="input-container"*ngIf="natsociete">
                <label for="choice" class="col-md-8 control-label"> Etes vous totalement exportateur:</label>    
                <div id="block1" *ngIf="natsociete"><input type="checkbox"  id="choice"class="input-field"formControlName="export">Oui</div>      
              </div>
          </td>
          <td>
            <div class="input-container">
            <label class="col-md-4 control-label"*ngIf="tot||userForm.controls['export'].value==true">Déclaration d'investissement</label>
                <div class="col-md-8 inputGroupContainer"*ngIf="tot||userForm.controls['export'].value==true">
                   <div class="input-group">
                      <span class="input-group-addon" style="max-width: 100%;"><i class="glyphicon glyphicon-asterisk" style="color: red;"></i></span>
                      <input type="file" style="border: 1px solid red" #filePicker (change)="onImagePick2($event)" class="form-control" accept="application/pdf">
                      <b><a href="{{user.ficheUrl2}}" target="_blank">Aperçu DI</a></b>
                    </div>
                </div>
            </div>
          </td>
          <td>
            <div class="input-container"*ngIf="natsociete">
                <label for="choice" class="col-md-8 control-label"> Avez vous une matricule CNSS:</label>    
                <div id="block3"><input type="checkbox"  id="choice3"class="input-field"formControlName="salaire">Oui</div>  
        </div>
          </td>
       
        </tr>
      </tbody>
      </table>-->  
  </fieldset>
  <button class="btn btn-success" (click)="onSubmit()" id="input12">Valider </button>
</form>
<p>{{ errormsg }}</p>
<div class="alert alert-success" *ngIf="isSuccessful">
  Modificaion effectuée avec succès!!
</div>
</div>
</div>
</body>